var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import DOMPurify from 'dompurify';
import QuestionnaireOrg from "../../../organisms/jsQuestionnaire/jsQuestionnaire";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AdviserDemographicsAction, AdviserDemographicsFormAction, } from "../../../../redux/actions/adviser_questionnaire";
import { getProfileData } from "../../../../redux/actions/profile";
import { Status } from "../../../../redux/constants/status";
/**
 * The Adviser Demographics Questionnaire Page
 * This will need to call all relevant APIs to get the values.
 * @param props
 * @returns
 */
function AdviserDemographicsQuestionnaire() {
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var _a = useState(''), error = _a[0], setError = _a[1];
    //using selector hook to fetch data from the reducer
    var _b = useSelector(function (state) { return state.rootReducer.AdviserQuestionnaireReducer; }), adviserDemographicsData = _b.adviserDemographicsData, error_adviserDemographics = _b.error_adviserDemographics, status = _b.status, adviserDemographicsFormData = _b.adviserDemographicsFormData, success_adviserDemographics_form = _b.success_adviserDemographics_form;
    var profileData = useSelector(function (state) { return state.rootReducer.profileReducer; });
    var alreadyCompleted = profileData.status === Status.Successful && !!profileData.demographics_complete;
    useEffect(function () {
        dispatch(getProfileData());
        if (!adviserDemographicsData || adviserDemographicsData.length === 0) {
            dispatch(AdviserDemographicsAction());
        }
    }, [dispatch]);
    var loginData = useSelector(function (state) { return state.rootReducer.userReducer; }).loginData;
    //function to submit the input user data
    var handleFormSubmit = function (formData) {
        var sanitizedData = Object.keys(formData).reduce(function (acc, key) {
            acc[key] = DOMPurify.sanitize(formData[key]);
            return acc;
        }, {});
        dispatch(AdviserDemographicsFormAction(sanitizedData, loginData));
    };
    var handleBackBtn = function () {
        navigate("/dashboard");
    };
    if (success_adviserDemographics_form) {
        navigate("/dashboard");
    }
    if (alreadyCompleted) {
        return (_jsx("div", __assign({ className: "" }, { children: _jsx(QuestionnaireOrg, { title: "Adviser Demographics", content: "", data: [], responses: {}, hideProgress: true, hideSubmit: true, emptyStateMessage: "This questionnaire has already been completed.", handleBackBtn: handleBackBtn, classname: "global-w" }) })));
    }
    return (_jsxs("div", __assign({ className: "" }, { children: [error && _jsx("div", __assign({ className: "error-message" }, { children: error })), _jsx(QuestionnaireOrg, { title: "Adviser Demographics", content: "", data: adviserDemographicsData, responses: adviserDemographicsFormData, loading: status === Status.Loading || profileData.status === Status.Loading, handleSubmit: handleFormSubmit, handleBackBtn: handleBackBtn, classname: "global-w", width: "100%", hideProgress: true, submitLabel: "Submit" })] })));
}
export default AdviserDemographicsQuestionnaire;
